import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Switchgear"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      putSwitchgearBySubstationAndName: build.mutation<
        PutSwitchgearBySubstationAndNameApiResponse,
        PutSwitchgearBySubstationAndNameApiArg
      >({
        query: (queryArg) => ({
          url: `/Switchgear/${queryArg.substation}/${queryArg.name}`,
          method: "PUT",
          body: queryArg.switchgearDto,
        }),
        invalidatesTags: ["Switchgear"],
      }),
      deleteSwitchgearBySubstationAndName: build.mutation<
        DeleteSwitchgearBySubstationAndNameApiResponse,
        DeleteSwitchgearBySubstationAndNameApiArg
      >({
        query: (queryArg) => ({
          url: `/Switchgear/${queryArg.substation}/${queryArg.name}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Switchgear"],
      }),
      getSwitchgear: build.query<GetSwitchgearApiResponse, GetSwitchgearApiArg>(
        {
          query: (queryArg) => ({
            url: `/Switchgear`,
            params: { substation: queryArg },
          }),
          providesTags: ["Switchgear"],
        }
      ),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as switchgearApi };
export type PutSwitchgearBySubstationAndNameApiResponse =
  /** status 200 OK */ void;
export type PutSwitchgearBySubstationAndNameApiArg = {
  substation: string;
  name: string;
  switchgearDto: SwitchgearDto;
};
export type DeleteSwitchgearBySubstationAndNameApiResponse = unknown;
export type DeleteSwitchgearBySubstationAndNameApiArg = {
  substation: string;
  name: string;
};
export type GetSwitchgearApiResponse = /** status 200 OK */ SwitchgearDto[];
export type GetSwitchgearApiArg = string;
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type SwitchgearDto = {
  name: string;
  number?: string | null;
  latitude?: number;
  longitude?: number;
  substation: string;
  comment?: string | null;
  isUsed: boolean;
};
export const {
  usePutSwitchgearBySubstationAndNameMutation,
  useDeleteSwitchgearBySubstationAndNameMutation,
  useGetSwitchgearQuery,
  useLazyGetSwitchgearQuery,
} = injectedRtkApi;
